import clsx from "clsx";

interface SectionProps {
  children: React.ReactNode;
  className?: string;
  /** Stack children with section gap */
  stacked?: boolean;
}

export function Section({ children, className, stacked = true }: SectionProps) {
  return (
    <section className={clsx("section-padding w-full", stacked && "flex flex-col section-gap", className)}>
      {children}
    </section>
  );
}
